import { createFileRoute } from '@tanstack/react-router'
import { AuditorAssetDetailsPage } from '@/components/auditor-center/AuditorAssetDetailsPage'
import { auditorAssetSearchSchema } from '@/components/auditor-center/AuditorAssetsPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/assets_/$assetId',
)({
  validateSearch: auditorAssetSearchSchema,
  component: AuditorAssetDetailsPage,
})
